import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Input, Col } from "antd";
var TextWidget = /*#__PURE__*/function (_PureComponent) {
  function TextWidget() {
    var _this;
    _classCallCheck(this, TextWidget);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TextWidget, [].concat(args));
    _this.handleChange = function (ev) {
      var v = ev.target.value;
      var val = v === "" ? undefined : v; // don't allow empty value
      _this.props.setValue(val);
    };
    return _this;
  }
  _inherits(TextWidget, _PureComponent);
  return _createClass(TextWidget, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        config = _this$props.config,
        placeholder = _this$props.placeholder,
        customProps = _this$props.customProps,
        value = _this$props.value,
        readonly = _this$props.readonly,
        maxLength = _this$props.maxLength;
      var renderSize = config.settings.renderSize;
      var aValue = value != undefined ? value : null;
      return /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Input, _extends({
        disabled: readonly,
        key: "widget-text",
        size: renderSize,
        type: "text",
        value: aValue,
        placeholder: placeholder,
        maxLength: maxLength,
        onChange: this.handleChange
      }, customProps)));
    }
  }]);
}(PureComponent);
TextWidget.propTypes = {
  setValue: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  config: PropTypes.object.isRequired,
  value: PropTypes.string,
  field: PropTypes.any,
  readonly: PropTypes.bool,
  customProps: PropTypes.object,
  maxLength: PropTypes.number
};
export { TextWidget as default };